import { render, staticRenderFns } from "./DictionarySubjectNames.vue?vue&type=template&id=19a5960c&scoped=true&"
import script from "./DictionarySubjectNames.vue?vue&type=script&lang=js&"
export * from "./DictionarySubjectNames.vue?vue&type=script&lang=js&"
import style0 from "./DictionarySubjectNames.vue?vue&type=style&index=0&id=19a5960c&scoped=true&lang=scss&"
import style1 from "./DictionarySubjectNames.vue?vue&type=style&index=1&id=19a5960c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a5960c",
  null
  
)

export default component.exports